import React from 'react';
import {observer} from 'mobx-react';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';
import Dropdown from 'core/components/Dropdown.js';
import Checkbox from 'core/components/Checkbox.js';
import Button from 'core/components/Button.js';

export default
@observer
class HospitalDirectoryHFRFilter extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    renderFilter() {
        const {
            filteredHospitalRelationships,
            filterByHealthFundRelationship,
            updateFilterParams,
            healthFundDisclaimer,
            rootStore: {
                healthFundStore: {hasHFRLoaded},
                paramStore: {hasSkin},
            },
        } = this.context;
        return (
            <>
                {!hasSkin && (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: healthFundDisclaimer,
                        }}
                    ></span>
                )}
                {filteredHospitalRelationships?.map((hfr) => {
                    return (
                        <Checkbox
                            checked={hfr.checked}
                            className={'filter'}
                            disabled={!hasHFRLoaded}
                            key={hfr.id}
                            name={hfr.name}
                            onChange={() => {
                                filterByHealthFundRelationship(hfr.id);
                            }}
                            type="checkbox"
                        >
                            {hfr.displayName}
                        </Checkbox>
                    );
                })}
                <Button
                    action={updateFilterParams}
                    customClass="cta"
                    isPreventDefault={true}
                    text={'Update search'}
                    type="submit"
                />
            </>
        );
    }

    render() {
        const {
            filteredHospitalRelationships,
            isHFRDropdownOpen,
            hfrDropdownHandler,
            healthFundDisclaimer,
            healthFundFilterText,
            rootStore: {
                healthFundStore: {healthFund},
                paramStore: {isClient, hasSkin},
            },
        } = this.context;
        if (!healthFund?.id || filteredHospitalRelationships?.length <= 2) {
            return null;
        }
        return (
            <>
                {hasSkin && !isClient && (
                    <form className="filters fund-info fund-relationship-info">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: healthFundDisclaimer,
                            }}
                        ></span>
                        <Dropdown
                            displayText={healthFundFilterText}
                            handleToggle={(status) =>
                                hfrDropdownHandler(status)
                            }
                            storeIsOpen={isHFRDropdownOpen}
                        >
                            {this.renderFilter()}
                        </Dropdown>
                    </form>
                )}
            </>
        );
    }
}
